import React, { useMemo } from 'react';

interface EmailPreviewPanelProps {
  bodyHtml: string;
  subject: string;
  variables: string[];
}

const SAMPLE_DATA: Record<string, string> = {
  '{{name}}': 'John Doe',
  '{{email}}': 'john@example.com',
  '{{password}}': '********',
  '{{license_type}}': 'Professional',
  '{{credits}}': '500',
  '{{app_name}}': 'BrandScapes AI',
  '{{app_url}}': 'https://app.brandscapes.ai',
  '{{support_email}}': 'support@brandscapes.ai',
  '{{date}}': new Date().toLocaleDateString(),
};

const EmailPreviewPanel: React.FC<EmailPreviewPanelProps> = ({ bodyHtml, subject, variables }) => {
  const previewHtml = useMemo(() => {
    let html = bodyHtml;
    for (const v of variables) {
      const sample = SAMPLE_DATA[v] || v.replace(/[{}]/g, '');
      html = html.replace(new RegExp(v.replace(/[{}]/g, '\\$&'), 'g'), `<span style="background:#fef3c7;padding:1px 4px;border-radius:3px;">${sample}</span>`);
    }

    return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <style>
    body {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      margin: 0; padding: 0; background: #f3f4f6;
    }
    .email-container {
      max-width: 600px; margin: 24px auto; background: #fff;
      border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      overflow: hidden;
    }
    .email-header {
      background: #4f46e5; color: #fff; padding: 20px 24px;
      font-size: 14px;
    }
    .email-header .subject { font-size: 16px; font-weight: 600; margin-top: 4px; }
    .email-body { padding: 24px; line-height: 1.6; color: #374151; }
    .email-body h1 { font-size: 24px; margin: 0 0 12px; color: #111827; }
    .email-body h2 { font-size: 20px; margin: 0 0 10px; color: #111827; }
    .email-body h3 { font-size: 16px; margin: 0 0 8px; color: #111827; }
    .email-body p { margin: 0 0 12px; }
    .email-body a { color: #4f46e5; }
    .email-body ul, .email-body ol { margin: 0 0 12px; padding-left: 24px; }
  </style>
</head>
<body>
  <div class="email-container">
    <div class="email-header">
      <div>To: john@example.com</div>
      <div class="subject">${subject || '(No subject)'}</div>
    </div>
    <div class="email-body">${html}</div>
  </div>
</body>
</html>`;
  }, [bodyHtml, subject, variables]);

  return (
    <iframe
      srcDoc={previewHtml}
      title="Email Preview"
      className="w-full border-0 rounded-b-lg"
      style={{ height: '500px' }}
      sandbox="allow-same-origin"
    />
  );
};

export default EmailPreviewPanel;
